import {Component, Input, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {LoginService} from '../../services/login.service';

@Component({
  selector: 'lnd-app-application-confirmation',
  templateUrl: './lnd-application-confirmation.component.html',
  styleUrls: ['./lnd-application-confirmation.component.css']
})
export class LndApplicationConfirmationComponent implements OnInit {

  isLand = false;
  DAMSApplicationId: string;
  linkTitle: string;
  linkToNextRoute: string;
  mailHref: string;
  workingDays = 10;
  showMonthlyAccountHolderMessage = true;
  showPayByChequeMessage = false;
  totalOrderAmount: number;
  sra:boolean= true

  constructor(private loginService: LoginService, private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit() {
    this.DAMSApplicationId = this.route.snapshot.queryParams['DAMSApplicationId'];
    const appType = this.route.snapshot.queryParams['AppType'];
    const totalOrderAmount = this.route.snapshot.queryParams['TotalOrderAmount'];
    if (appType === 'lnd-w') {
      this.isLand = true;
      this.totalOrderAmount = totalOrderAmount;
      this.showMonthlyAccountHolderMessage = false;
      this.showPayByChequeMessage = true;
      this.linkTitle = 'Application to extend and/or upgrade a Greater Western Water sewer and/or water main';
      this.workingDays = 45;
      this.linkToNextRoute = '/lnd-w';
      this.mailHref = 'mailto:designs@gww.com.au?Subject=Development%20works%20application%20enquiry';
    }
  }

  // get isGuestUserLoggedIn(): boolean {
  //   return this.loginService.isGuestUserLoggedIn();
  // }

  ok() {
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/lnd-application-confirmation/lnd-application-confirmation.component.ts